var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"disabled":_vm.disabled},on:{"click":_vm.deleteUser}},[_c('i',{staticClass:"fa-trash"}),_vm._v(" Permanently Delete\n")])}
var staticRenderFns = []

export { render, staticRenderFns }